import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppSettings } from '../../../../../app.settings';

@Injectable({
  providedIn: 'root'
})
export class EmailfileuploadService {

  //Base_url = 'https://matrixemail.canstringai.com/api/';
  Base_url =  `${AppSettings.EMAIL_API_ENDPOINT}`;
  fileUrl = this.Base_url+'/get-topic/1';
  topicUrl = this.Base_url+'/get-keywords';
  postFileUrl = this.Base_url+'/audio-file-upload';
  postPdfUrl = this.Base_url+'/sentiment-pdf';
  postTexturl = this.Base_url+'/sentiment-text-file';
  postEmailUrl = this.Base_url+'/email-upload';
  uploadExcelUrl = this.Base_url+'/upload-excel';
  topicKeywordUrl = this.Base_url+'/config';

  uploadEmailExcelUrl = this.Base_url+'/upload-xlsx';
  uploadTextfileUrl=this.Base_url+'/upload-text';

  constructor(private http: HttpClient) { }

  getFile(){
    return this.http.get(this.fileUrl);
  }
  
  getTopic(){
    return this.http.get(`${this.topicKeywordUrl}`);
  }

  uploadFile(data:any){
    return this.http.post(this.postFileUrl, data);
  }

  uploadPdf(data:any){
    return this.http.post(this.postPdfUrl, data);
  }

  // uploadText(data:any){
  //   return this.http.post(this.postTexturl, data);
  // }

  uploadEmail(data:any){
    return this.http.post(this.postEmailUrl, data);
  }

  uploadExcel(config_id:any,data:any){
    return this.http.post(this.uploadExcelUrl+'/'+config_id,data);
  }

  uploadEmailExcel(config_id:any,data:any){
    return this.http.post(this.uploadEmailExcelUrl+'/'+config_id,data);
  }


  uploadText(config_id:any,data:any){
    return this.http.post(this.uploadTextfileUrl+'/'+config_id,data);
  }
}
